<template>
  <div class="d-flex align-items-start flex-column h-100">
    <div class="basket-header w-100 pt-1">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h5 class="float-left">
              <svg
                class="bi"
                width="1.5rem"
                height="1.5rem"
                fill="currentColor"
                style="margin-right: 5px; cursor: pointer"
                @click="closeBasket()"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x"
                />
              </svg>
              <span v-if="display_mode === 'basket'">Your Basket</span>
              <span v-if="display_mode === 'expired'">Expired Baskets</span>
            </h5>
            <!-- <b-link
              v-if="
                display_mode === 'basket' &&
                !isCheckout &&
                !$store.state.user.is_guest
              "
              class="float-right text-right small"
              @click="display_mode = 'expired'"
            >
              Expired baskets...
            </b-link>
            <b-link
              v-if="display_mode === 'expired' && !isCheckout"
              class="float-right text-right small"
              @click="display_mode = 'basket'"
            >
              View Basket
            </b-link> -->
          </div>
        </div>
      </div>
    </div>
    <basket-expiry></basket-expiry>
    <basket-item-list v-if="display_mode === 'basket'"></basket-item-list>
    <basket-summary
      :is-checkout="isCheckout"
      v-if="display_mode === 'basket'"
    ></basket-summary>
    <expired-baskets v-if="display_mode === 'expired'"></expired-baskets>
  </div>
</template>

<script>
import ZUX from "@/modules/ZUX";

import Vue from "vue";

import { mapGetters } from "vuex";

import BasketExpiry from "@/components/BasketExpiry";
import BasketItemList from "@/components/BasketItemList";
import BasketSummary from "@/components/BasketSummary";
import ExpiredBaskets from "@/components/ExpiredBaskets";

import { ButtonPlugin } from "bootstrap-vue";

Vue.use(ButtonPlugin);

export default {
  data() {
    return {
      display_mode: "basket",
    };
  },
  components: {
    BasketExpiry,
    BasketItemList,
    BasketSummary,
    ExpiredBaskets,
  },
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("readiness", ["is_ready"]),
  },
  methods: {
    closeBasket() {
      return ZUX.hideBasket();
    },
  },
};
</script>